<!-- <div class="mainContent"> -->
<div class="deskto_p scroll">
  <div class="row"></div>
  <div class="member_det mob_pad">
    <h1 style="font-size: 24px">{{ page.header }}</h1>
    
    <ng-container *ngFor="let content of page.content">
      <ng-container [ngSwitch]="content.key">
        <div
          class="row genericCallbox"
          *ngSwitchCase="TEMPLATE_KEY.SupportContact"
        >
          <callbox *ngIf="content?.value">{{ content?.value }}</callbox>
        </div>
        <div class="row" *ngSwitchCase="TEMPLATE_KEY.PayeeProfile">
          <div class="benefit-box" *ngIf="benefits.length">
            <p class="title">Benefit: </p>
            <select
              *ngIf="benefits.length > 1"
              class="benefit-select"
              (change)="benefitOnChange($event)"
            >
              <ng-container *ngFor="let benefit of benefits;">
                <option [value]="benefit.benefitId">{{ benefit.benefitName }}</option>
              </ng-container>
            </select>
            <p *ngIf="benefits.length === 1" class="title" style="font-weight: 400;">{{selectedBenefit.benefitName}}</p>
          </div>
          <ng-container class="for_grd">
            <div *ngIf="benefits.length > 0 && !loading" class="mem_container">
              <div class="mem_info l_st_con ng-star-inserted">
                <div class="row topmargin15">
                  <h2>Pension Effective Date</h2>
                </div>
                <div class="row col_value">
                  <div class="col_value">
                    <h3>{{ memberBenefitData.pensionEffectiveDate ? (memberBenefitData.pensionEffectiveDate | date: 'MM/dd/yyyy') : '' }}</h3>
                  </div>
                </div>
              </div>
              <div class="mem_info l_st_con ng-star-inserted">
                <div class="row topmargin15">
                  <h2>Monthly Pension Amount</h2>
                </div>
                <div class="row col_value">
                  <div class="col_value">
                    <h3>{{ memberBenefitData.monthlyPensionAmount || memberBenefitData.monthlyPensionAmount === 0 ? '$'+(memberBenefitData.monthlyPensionAmount | number: '1.2-2') : '' }}</h3>
                  </div>
                </div>
              </div>
              <div class="mem_info l_st_con ng-star-inserted">
                <div class="row topmargin15">
                  <h2>COLA Percent</h2>
                </div>
                <div class="row col_value">
                  <div class="col_value">
                    <h3>{{ memberBenefitData.colaPercent || memberBenefitData.colaPercent === 0 ? (memberBenefitData.colaPercent + '%') : '' }}</h3>
                  </div>
                </div>
              </div>
              <div  class="mem_info l_st_con ng-star-inserted">
                <div class="row topmargin15">
                  <h2>COLA Increase</h2>
                </div>
                <div class="row col_value">
                  <div class="col_value">
                    <h3>{{ memberBenefitData.colaIncreaseAmount || memberBenefitData.colaIncreaseAmount === 0 ? '$' + (memberBenefitData.colaIncreaseAmount | number: '1.2-2') : '' }}</h3>
                  </div>
                </div>
              </div>
              <div class="mem_info l_st_con ng-star-inserted">
                <div class="row topmargin15">
                  <h2>COLA Total</h2>
                </div>
                <div class="row col_value">
                  <div class="col_value">
                    <h3>{{ memberBenefitData.colaTotalAmount || memberBenefitData.colaTotalAmount === 0 ? '$' + (memberBenefitData.colaTotalAmount | number: '1.2-2') : '' }}</h3>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </ng-container>
    </ng-container>
  </div>
</div>
